import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-settlement-insurance',
  templateUrl: './settlement-insurance.component.html',
  styleUrls: ['./settlement-insurance.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SettlementInsuranceComponent implements OnInit {
  @Input() matterAddressForm: FormGroup;
  @Input() errorWarningData: any;
  constructor(public datepipe: DatePipe) {}

  ngOnInit(): void {}

  ResolutionDatepicker(type: string, event: MatDatepickerInputEvent<Date>) {
    this.matterAddressForm.controls['INSURANCEEXPIRYDATE'].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }
}
